import { useId } from 'react';

import { Input } from '@/components/ui/input';
import { SegmentButton } from '@/components/ui/segment-button';
import type {
  EmailPicker,
  PickerMode,
} from '@/features/proactive-agents/useEmailPicker';
import { AdditionalEmailsInput } from '@/features/proactivity-experiments/AdditionalEmailsInput';

export const EmailPickerFields = ({
  label,
  picker,
}: {
  label: string;
  picker: EmailPicker;
}) => {
  const labelId = useId();
  const options: { value: PickerMode; label: string }[] = [
    ...(picker.everyoneLabel
      ? [{ value: 'everyone' as const, label: picker.everyoneLabel }]
      : []),
    { value: 'emails', label: 'Specific emails' },
    { value: 'contains', label: 'Email contains' },
  ];
  return (
    <div role="group" aria-labelledby={labelId} className="grid gap-3 text-sm">
      <span id={labelId}>{label}</span>
      <SegmentButton
        options={options}
        selected={picker.mode}
        onSelect={picker.setMode}
      />
      {picker.mode === 'emails' ? (
        <AdditionalEmailsInput
          label="Emails"
          emails={picker.emails}
          onChange={picker.setEmails}
        />
      ) : null}
      {picker.mode === 'contains' ? (
        <>
          <Input
            aria-label="Email contains"
            value={picker.emailContains}
            onChange={(event) => picker.setEmailContains(event.target.value)}
            placeholder="@littlebird.ai"
          />
          {/* A picker with an everyone mode needs no hint, since that mode does what "." would */}
          {picker.everyoneLabel ? null : (
            <p className="text-muted-foreground">"." matches every email.</p>
          )}
        </>
      ) : null}
    </div>
  );
};
